// @flow
import React from 'react';
import Icon from 'Components/Icon';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import { firstLevelTracking } from 'Utils/trackingAttributes';

const cx = classNames.bind(styles);

type Props = {
  id: string,
  entry: Object,
  active: boolean,
  open: boolean,
  forceMobileMenu: boolean,
  ariaControls: string,
  onClick: (entry: Object) => void,
  onKeyDown: (event: Event, entry: Object) => void,
};

type State = {
  open: boolean,
};

export default class MainEntry extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  onClick = () => {
    this.props.onClick(this.props.entry);
  };

  onKeyDown = (event) => {
    this.props.onKeyDown(event, this.props.entry);
  };

  render() {
    const { id, entry, open, active, forceMobileMenu, ariaControls } = this.props;
    const dfmm = { 'data-force-mobile-menu': forceMobileMenu };

    const navItemClass = cx('main-nav__item', {
      'main-nav__item--open': open,
      'main-nav__item--active': active && !open,
    });

    return (
      <li
        key={entry.to}
        data-name={entry.label}
        className={navItemClass}
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
        {...dfmm}
      >
        <button
          {...firstLevelTracking(entry.label)}
          id={id}
          aria-controls={ariaControls}
          aria-label={entry.label}
          aria-haspopup="menu"
          aria-expanded={open}
        >
          {entry.label}
        </button>
        <Icon name="caret-left" className={styles.icon} inline={false} />
      </li>
    );
  }
}
